var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumidityAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.9999C16.4183 21.9999 20 18.2689 20 13.6666C20 10.2323 15.5454 5.42712 13.2843 3.20928C12.5641 2.50283 11.4359 2.50283 10.7157 3.20928C8.45459 5.42712 4 10.2323 4 13.6666C4 18.2689 7.58172 21.9999 12 21.9999ZM9.5 12.9999C8.67157 12.9999 8 12.3283 8 11.4999C8 10.6715 8.67157 9.99994 9.5 9.99994C10.3284 9.99994 11 10.6715 11 11.4999C11 12.3283 10.3284 12.9999 9.5 12.9999ZM15.5303 10.4696C15.8232 10.7625 15.8232 11.2373 15.5303 11.5302L9.53033 17.5302C9.23744 17.8231 8.76256 17.8231 8.46967 17.5302C8.17678 17.2373 8.17678 16.7625 8.46967 16.4696L14.4697 10.4696C14.7626 10.1767 15.2374 10.1767 15.5303 10.4696ZM14.5 17.9999C13.6716 17.9999 13 17.3283 13 16.4999C13 15.6715 13.6716 14.9999 14.5 14.9999C15.3284 14.9999 16 15.6715 16 16.4999C16 17.3283 15.3284 17.9999 14.5 17.9999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidityAlt);
export default __webpack_public_path__ + "static/media/humidity-alt.0f2c6662a3bdaf761402522c5343c21f.svg";
export { ForwardRef as ReactComponent };